module.exports = __webpack_public_path__ + "img/9f85bb9.jpg";